import styled from 'styled-components';

import { respondDown } from 'styles/mixins';
import { Breakpoints, COLORS } from 'styles/style-constants';

export const Head = styled.div`
    display: flex;
    align-items: center;
    min-height: 5.2rem;
    padding: 0.8rem;
    font-size: 1.4rem;
    line-height: 2rem;
    color: ${COLORS.textGray};

    ${respondDown(Breakpoints.md)`display: none;`}
`;

export const Row = styled.div`
    display: flex;
    align-items: center;
    min-height: 11.4rem;
    padding: 0.8rem;
    border: 0.1rem solid ${COLORS.transparent};
    border-radius: 0.5rem;

    ${respondDown(Breakpoints.md)`
        flex-direction: column;
        align-items: stretch;
        background: ${COLORS.surface};
        padding: 2.7rem 1.6rem 1.6rem;
        margin-bottom: 1.6rem;
        gap: 1.6rem;
    `}
`;

export const Cell = styled.div<{ $market?: boolean }>`
    flex: ${({ $market }) => ($market ? 1.5 : 1)};
    display: flex;
    align-items: center;
    justify-content: ${({ $market }) => ($market ? 'flex-start' : 'flex-end')};
    font-size: 1.4rem;
    line-height: 2rem;
    white-space: nowrap;

    & > svg {
        margin-left: 0.4rem;
    }
    & > span {
        display: none;
    }

    ${respondDown(Breakpoints.md)`
        min-height: 2.8rem;
        justify-content: space-between;
        & > span { display: block; color: ${COLORS.textGray}; }
        &:last-child { margin-bottom: 1.6rem; }
    `}
`;
